// This reducer is for any parameter that is not closely tied to a singular module or page
import { createReducer, on } from '@ngrx/store';

import { Material } from '@shared/models/cost.interface';

import { UpdateSelectedMaterialCost } from '../actions/cost.actions';
import { UpdateSelectedMaterialCI } from '../actions/carbon-impact.actions';

export const sharedFeatureKey = 'shared';

export interface State {
  selectedMaterial: Material;
}

export const initialState: State = {
  selectedMaterial: 'Concrete',
};

export const reducer = createReducer(
  initialState,
  on(
    UpdateSelectedMaterialCost,
    UpdateSelectedMaterialCI,
    (state, { selectedMaterial }) => {
      return {
        ...state,
        selectedMaterial,
      };
    }
  )
);

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const selectSelectedMaterial = (state: State) => state.selectedMaterial;
